module.exports = __webpack_public_path__ + "banner.0b82b0f9219cb2dd8413.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/fmancia/repo/gitlab/frontend-snj/src/assets/images/banner.jpg
// module id = ../../../../../src/assets/images/banner.jpg
// module chunks = 2